module.exports = __webpack_public_path__ + "img/icon_submenu12dark.d41a6d9c.svg";